import React from 'react';
import PageBanner from "@/components/pageBanner";

const AffiliateProgramRegulations = () => {
    return (
        <>
            <PageBanner title="Affiliate Program Regulations" slug="affiliate-program-regulations" />
            <section className="generic-container py-14">
                <p className={`font-bold text-lt-blue text-2xl`}>ENTRY</p>
                <p className={`mt-4 text-justify`}>
                    These regulations define the rules of participation in the affiliate program run by Locked Trade LLC, 40 Wall St. 28th Floor, New York City, NY 10005, USA, EIN 38-4348564 (hereinafter "Organizer").<br/><br/>
                    By using the affiliate program, the participant (hereinafter "Partner") accepts all the conditions
                    specified in these regulations. These regulations are binding for all participants of the affiliate
                    program.
                </p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>DEFINITIONS</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li><strong>Affiliate Program</strong> – an initiative run by the Organizer, under which Partners
                        can obtain access to additional services in exchange for promoting and recommending the
                        Organizer's services or products.
                    </li>
                    <li><strong>Partner</strong> – a natural or legal person who joins the affiliate program after
                        accepting the regulations and meeting certain requirements.
                    </li>
                    <li><strong>Referred Customer</strong> – a person who purchases the Organizer’s product or service
                        via a unique affiliate link provided to the Partner.
                    </li>
                    <li><strong>Affiliate link</strong> – a unique link assigned to the Partner in order to monitor and
                        record the activity of referred Customers.
                    </li>
                    <li><strong>Affiliate Reward</strong> – access to a virtual assistant offered to the Partner in
                        exchange for effective recommendations.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>RULES FOR ENTERING THE PROGRAM</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li>A natural person with full legal capacity or a legal person may join the affiliate program.</li>
                    <li>Registration in the program takes place via the application form available on the Organizer's
                        website.
                    </li>
                    <li>The organiser reserves the right to verify application data and to refuse to accept an
                        application without giving a reason.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>PRINCIPLES OF PROGRAM OPERATION</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li>The Partner receives a unique affiliate link which is used to recommend the Organizer's services
                        or products.
                    </li>
                    <li>The referred customer must make a purchase through the affiliate link in order for the Affiliate
                        to receive the affiliate reward.
                    </li>
                    <li>All transactions are registered in the Organizer's affiliate system, and the Partner has access
                        to their panel with the results of promotional activities.
                    </li>
                    <li>Access to the virtual assistant is granted for a specified period of time, in accordance with
                        the rules of the affiliate program, after the Partner meets the requirements.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>PRIZE</p>
                <ol className={`mt-4 text-left list-decimal ml-4`}>
                    <li>The Partner receives a reward in the form of access to a virtual assistant after successfully
                        recommending a certain number of referred Clients or after reaching another established activity
                        threshold.
                    </li>
                    <li>Detailed rules for awarding the prize are specified in the Partner panel and may be updated by
                        the Organizer.
                    </li>
                    <li>The Organizer reserves the right to verify instructions and withhold the award of the prize in
                        the event of a suspected violation of the regulations.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>PARTNER OBLIGATIONS</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li>The Partner undertakes to promote the Organizer’s services and products in a manner consistent
                        with the law and good customs.
                    </li>
                    <li>It is prohibited to disseminate false information about the Organizer, its products or
                        services.
                    </li>
                    <li>The Partner may not use affiliate links in spam campaigns, fraudulent campaigns or campaigns
                        that violate the rights of third parties.
                    </li>
                    <li>In the event of violation of the rules of the affiliate program, the Organizer may terminate
                        cooperation with the Partner with immediate effect.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>ORGANIZER'S RESPONSIBILITY</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li>The Organizer undertakes to ensure the efficient operation of the affiliate system and the
                        timely awarding of affiliate prizes.
                    </li>
                    <li>The Organizer is not liable for any damage resulting from improper use of the program by the
                        Partner.
                    </li>
                    <li>The Organizer reserves the right to make changes to the Affiliate Program Regulations. Partners
                        will be informed of any changes 14 days in advance.
                    </li>
                </ol>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>FINAL PROVISIONS</p>
                <ol className={`mt-4 text-justify list-decimal ml-4`}>
                    <li>The Regulations come into force on the date of their publication on the Organizer's website.
                    </li>
                    <li>All disputes related to the implementation of the affiliate program will be resolved by the
                        court having jurisdiction over the registered office of the Organizer.
                    </li>
                    <li>In matters not regulated by these regulations, the provisions of Polish law shall apply.</li>
                </ol>
                <p className={`mt-4 text-justify`}>
                    For any questions regarding the affiliate program, please contact us at: <a
                    href="mailto:support@lockedtrade.com"
                    className={`text-lt-blue`}>support@lockedtrade.com</a>
                </p>
            </section>
        </>
    );
};

export default AffiliateProgramRegulations;